import React from "react";
import type { GatsbyBrowser } from "gatsby";
import { config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";

config.autoAddCss = false;
import "./src/styles/global.css";

import { RootWrapper } from "./src/components/layouts/RootWrapper";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => {
  return <RootWrapper>{element}</RootWrapper>;
};
